import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/brand/brand_1.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/brand/brand_2.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/brand/brand_3.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/brand/brand_4.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/brand/brand_5.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/brand/brand_6.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/brand/brand_7.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/brand/brand_8.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/brand/brand_9.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/herobanner/herobanner__1.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/herobanner/herobanner__2.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/herobanner/herobanner__3.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/assets/images/herobanner/herobanner__5.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/layout/main/AboutMain.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/abouts/AboutContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/abouts/AboutPageContent.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/abouts/AtMedh.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/abouts/WhoWeAre.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/abouts/WhyChooseMEDH.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2379967965/src/medh-web/src/components/sections/featured-courses/FeatureCourses.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2379967965/src/medh-web/src/components/shared/wrappers/PageWrapper.tsx");
